import styled from 'styled-components';
import { UserAvatar } from '@vs-online-only-app/ui';
import { Alert, Stack, Typography } from '@mui/material';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';

const Wrapper = styled(Stack)`
  flex-direction: column;
  justify-content: center;
  grid-column: 1 / 3;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  z-index: 2;
`;

export const SelectedArchivedConversationHeader = () => {
  const conversation = useSelectedHeroConversation();

  if (!conversation) {
    return null;
  }

  return (
    <Wrapper>
      <Stack
        gap={1}
        padding={(theme) => theme.spacing(1.5, 3)}
        alignItems="center"
        direction="row"
      >
        <UserAvatar
          fallbackCharacter={conversation?.conversationStarter?.firstName
            .charAt(0)
            .toUpperCase()}
        />
        <Typography fontWeight="bold">
          {conversation.conversationStarter.firstName}
        </Typography>
      </Stack>
      <Alert severity="info" sx={{ borderRadius: 0 }}>
        This chat has been ended and can only be restarted by the customer.
      </Alert>
    </Wrapper>
  );
};
